export default "__VITE_ASSET__04666ccf__"